import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock, FiDollarSign, FiHome, FiCheckCircle, FiX, FiTool } = FiIcons;

const Benefits = () => {
  const benefits = [
    {
      icon: FiClock,
      title: "Close in 7 Days",
      description: "No lengthy mortgage approvals. We can close in as little as 7 days or on your timeline."
    },
    {
      icon: FiDollarSign,
      title: "All Cash Offers",
      description: "No financing contingencies. We pay cash, so you don't have to worry about deals falling through."
    },
    {
      icon: FiHome,
      title: "Any Condition",
      description: "We buy houses as-is. No need to clean, repair, or stage your property before selling."
    },
    {
      icon: FiX,
      title: "No Fees or Commissions",
      description: "No real estate agent commissions, closing costs, or hidden fees. What we offer is what you get."
    },
    {
      icon: FiCheckCircle,
      title: "Fair Market Value",
      description: "We provide competitive cash offers based on current market conditions and your property's value."
    },
    {
      icon: FiTool,
      title: "No Repairs Needed",
      description: "Sell your house exactly as it is. We handle all repairs and renovations after purchase."
    }
  ];

  return (
    <section id="benefits" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Why Sell to <span className="text-red-600">cash</span>x24.com?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Skip the hassles of traditional home selling. We make the process simple, 
            fast, and profitable for you.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-gray-50 p-8 rounded-xl hover:shadow-lg transition-shadow duration-300 border-t-4 border-transparent hover:border-red-600"
            >
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                <SafeIcon icon={benefit.icon} className="w-8 h-8 text-red-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;